import React, { useState } from 'react';
import { Mail, Save } from 'lucide-react';

const AdmissionEmailManager = ({ pageData, onUpdate }) => {
  const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
  const [email, setEmail] = useState(pageData.admission_email || '');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSave = async () => {
    setLoading(true);
    setMessage(null);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE}/api/admin/site/pages/admission/email`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage({ type: 'success', text: 'Email mis à jour avec succès !' });
        if (onUpdate) onUpdate();
      } else {
        const error = await response.json();
        setMessage({ type: 'error', text: error.detail || 'Erreur lors de la mise à jour' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Erreur de connexion' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold mb-4" style={{ color: 'rgb(196, 150, 96)' }}>
        Configuration du formulaire d'admission
      </h2>

      {message && (
        <div className={`mb-4 p-4 rounded-lg ${
          message.type === 'success' ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
        }`}>
          {message.text}
        </div>
      )}

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Mail className="inline w-4 h-4 mr-2" />
            Email de réception des demandes d'admission
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="exemple@lignagesdebruxelles.be"
          />
          <p className="text-sm text-gray-500 mt-1">
            Les demandes d'admission soumises via le formulaire seront envoyées à cette adresse
          </p>
        </div>

        <button
          onClick={handleSave}
          disabled={loading || !email}
          className="flex items-center gap-2 px-4 py-2 text-white rounded-lg"
          style={{ backgroundColor: 'rgb(196, 150, 96)' }}
        >
          <Save className="w-4 h-4" />
          {loading ? 'Enregistrement...' : 'Enregistrer l\'email'}
        </button>
      </div>
    </div>
  );
};

export default AdmissionEmailManager;
